import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';
import { TEXT_COLOURS, BRANDED_COLOURS, OREGON_COLOURS, GRADIENTS, SPIKES_COLOURS } from '@constants';

export const IMAGE_KEY = 'IMAGE';
export const COLOR_KEY = 'COLOR';

export const FORM_FIELD = {
  TITLE: {
    name: 'title',
    label: 'Title (optional):',
  },
  TAG: {
    name: 'tag',
    label: 'Start typing a tag...',
    rules: [{ required: true, message: 'A content tag is required' }],
    serialize: utils.relatedEntitySerializer,
    deserialize: utils.relatedEntityDeserializer,
  },
  [IMAGE_KEY]: {
    label: 'Image',
    name: 'image',
    rules: [{ required: true, message: 'An image is required' }],
    size: IMAGE_SIZE['2000x714'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
  MORE_NEWS_LINK: {
    name: 'moreNewsLink',
    label: 'More news link:',
    placeholder: 'Enter a more news link',
    rules: [{ type: 'url', message: "Doesn't look like a valid URL" }],
  },
  [COLOR_KEY]: {
    name: 'colour',
    label: 'Colour',
    colors: [...TEXT_COLOURS, ...BRANDED_COLOURS, ...OREGON_COLOURS, ...SPIKES_COLOURS, GRADIENTS['gradient-1'].key],
    rules: [{ required: true, message: 'A colour is required' }],
  },
};
